const ErrorMessage = ({ message }) => {
	return <span className="text-orange-2000 text-xs mt-0.5">{message}</span>;
};

export default ErrorMessage;
